<script>
	import { Router, Route } from "svelte-navigator";
	import moduleSanatoriums from "./module/moduleSanatoriums.svelte";
	import HomePage from "./module/HomePage.svelte";
	import WorkingOut from "./module/workingOut.svelte";
	import moduleGuide from "./module/moduleGuide.svelte";
    import { onMount } from 'svelte';
    import FormBuy from "./module/formBuy.svelte";

	onMount(() => {
        // Небольшая задержка, чтобы браузер успел рендерить страницу
        setTimeout(() => { 
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
            // или window.scrollTo(0, 0); для мгновенной прокрутки без анимации
        }, 100);
    });
</script>

<Router>
	<Route path="/" component={HomePage} />
	<Route path="/sanatoriums" component={moduleSanatoriums} />
	<Route path="/workingOut" component={WorkingOut} />
	<Route path="/guide" component={moduleGuide} />
	<Route path="/formBuy" component={FormBuy} />
</Router>

<style>
	:global(html) {
		scroll-behavior: smooth;
	}
</style>
